import { FunctionalComponent } from 'preact';
import { useState } from 'preact/hooks';
import { stylesheet } from 'astroturf';
import { Nav } from '@accedo/spatial-nav';
import UnfocusedButton from '##/assets/images/UnfocusedBackToTopButton.svg';
import FocusedButton from '##/assets/images/FocusedBackToTopButton.svg';
import { scrollThenFocus } from '##/utils/scroll';
import {
  MARQUEE_BUTTON_NAV_ID,
  SIDE_MENU_NAV_ID,
  safeAssignFocus,
  isHomeRoute,
} from '##/utils';
import { nav } from '##/init';
import { useKeyPress } from '##/utils/hooks';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .button-container {
    width: 100vw;
    padding-left: pxToVw(109);
    margin-top: 5vh;
    display: flex;
    align-items: center;
  }
`;

type propTypes = {
  id: string;
  index: number;
};

export const BackToTopButton: FunctionalComponent<propTypes> = (props) => {
  const { id, index } = props;
  const [isFocused, setIsFocused] = useState(false);

  const onButtonClick = (): void => {
    scrollThenFocus('page-scroll', 0, MARQUEE_BUTTON_NAV_ID);
    setIsFocused(false);
  };

  useKeyPress('BACK', () => {
    if (
      nav.currentFocusNodeId === id &&
      isHomeRoute(window.location.pathname)
    ) {
      safeAssignFocus(SIDE_MENU_NAV_ID);

      return true;
    }

    return false;
  });

  return (
    <div id={id} data-scroll-offset={-300}>
      <Nav.Focusable
        id={id}
        index={index}
        onSelect={onButtonClick}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      >
        <div className={styles.buttonContainer}>
          {isFocused ? <FocusedButton /> : <UnfocusedButton />}
        </div>
      </Nav.Focusable>
    </div>
  );
};
